"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValidationService = void 0;
var SetValidationService_1 = require("./implementation/SetValidationService");
exports.setValidationService = new SetValidationService_1.SetValidationService();
//# sourceMappingURL=index.js.map